import { Box, Typography } from '@mui/material';
import { couponUnavailableCouponSrc, couponUnavailableCrossSrc } from '../../assets/bazzar';
import { buildCouponUnavailableMessage } from '../../services/bazaarService';
import {
  BazaarActionButton,
  BazaarDialogShell,
  BazaarRibbonTitle,
} from './bazaarDialogShared';

/** Figma 10040:6873 — coupon unavailable popup */
const DIALOG_MIN_HEIGHT = 394;
const CONTENT_WIDTH = 306;

/** Figma 10040:6894 + 10040:6895 */
function CouponUnavailableIllustration() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 93,
        height: 77,
        mx: 'auto',
        mt: 2.5,
      }}
    >
      <Box
        sx={{
          width: 93,
          height: 75,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          component="img"
          src={couponUnavailableCouponSrc}
          alt=""
          aria-hidden="true"
          sx={{
            position: 'absolute',
            width: '112.28%',
            height: '137.99%',
            maxWidth: 'none',
            left: '-7.79%',
            top: '-18.52%',
            display: 'block',
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: 27,
          height: 27,
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={couponUnavailableCrossSrc}
          alt=""
          aria-hidden="true"
          sx={{
            position: 'absolute',
            width: '303.56%',
            height: '202.37%',
            maxWidth: 'none',
            left: '-28.26%',
            top: '-47.43%',
            display: 'block',
          }}
        />
      </Box>
    </Box>
  );
}

/** Figma 10040:6876 */
const messageTextSx = {
  fontFamily: 'Inter, sans-serif',
  color: '#fff',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.8px',
  textAlign: 'center',
  width: '100%',
  maxWidth: CONTENT_WIDTH,
  mx: 'auto',
};

export default function CouponUnavailableDialog({ open, onClose, result }) {
  const message = buildCouponUnavailableMessage(result);

  return (
    <BazaarDialogShell open={open && Boolean(result)} onClose={onClose} minHeight={DIALOG_MIN_HEIGHT}>
      <BazaarRibbonTitle tone="error" ribbonVariant="error">
        Oops, Unavailable!
      </BazaarRibbonTitle>

      <CouponUnavailableIllustration />

      <Typography sx={{ ...messageTextSx, mt: 2.5 }}>{message}</Typography>

      <Box sx={{ mt: 3, px: 0.5 }}>
        <BazaarActionButton label="Try Other" onClick={onClose} />
      </Box>
    </BazaarDialogShell>
  );
}
